import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import FeaturesSlider from "@/components/Features/Features";
import { Container } from "@mui/material";

const Features = () => {
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <FeaturesSlider />
    </>
  );
};

export default Features;
